import { ArrowRight } from "lucide-react";
import demo from "../assests/demo.png";

const FeaturedCollection = () => {
  return (
    <section className="featured-section">
      <div className="featured-container">

        {/* LEFT CONTENT */}
        <div className="featured-content">

          <span className="featured-tag">
            FEATURED COLLECTION
          </span>

          <h2 className="featured-title">
            Korean Innovation.
            <br />
            Crafted For
            <br />
            Indian Skin.
          </h2>

          <p className="featured-description">
            Every Celiora formula blends advanced Korean skincare
            science with ingredients carefully selected for Indian
            skin, delivering hydration, radiance and long-lasting
            skin health.
          </p>

          <button className="featured-btn">
            Explore Collection
            <ArrowRight size={18} />
          </button>

        </div>

        {/* RIGHT IMAGE */}

        <div className="featured-image-wrapper">

          {/* Decorative Circle */}

          <div className="featured-circle"></div>

          {/* Glow */}

          <div className="featured-glow"></div>

          {/* Product */}

          <img
            src= {demo}
            alt="Featured Collection"
            className="featured-image"
          />

          {/* Floating Badge */}

          <div className="floating-card">

            <span>NEW ARRIVAL</span>

            <h5>Glow Ritual Collection</h5>

            <p>Hydration • Brightening • Barrier Repair</p>

          </div>

        </div>

      </div>
    </section>
  );
};

export default FeaturedCollection;